import _ from 'lodash';
import { inlineSvg, inlineAsset } from './inline-svg.js';

const IMAGE_EXT_REGEX = /\.(png|jpe?g|gif|webp)$/i;

export function installInlineSvgHelpers(app) {
  if (!app || !app.config || !app.config.globalProperties) return;

  const globals = app.config.globalProperties;

  if (!globals.__vite_inline_svg_helper) {
    globals.__vite_inline_svg_helper = inlineSvg;
  }

  if (!globals.__vite_inline_asset_helper) {
    globals.__vite_inline_asset_helper = inlineAsset;
  }

  if (typeof window !== 'undefined' && !globals.window) {
    globals.window = window;
  }

  if (!app.__vite_inline_svg_mixin_registered) {
    app.mixin({
      created() {
        if (!this.__vite_inline_svg_helper) {
          this.__vite_inline_svg_helper = inlineSvg;
        }
        if (!this.__vite_inline_asset_helper) {
          this.__vite_inline_asset_helper = inlineAsset;
        }
      },
    });
    app.__vite_inline_svg_mixin_registered = true;
  }
}

if (typeof window !== 'undefined') {
  if (!window._) {
    window._ = _;
  }

  if (!window.__vite_inline_svg__) {
    window.__vite_inline_svg__ = inlineSvg;
  }

  if (typeof window.__vite_inline_svg_helper !== 'function') {
    window.__vite_inline_svg_helper = inlineSvg;
  }

  if (typeof window.__vite_inline_asset__ !== 'function') {
    window.__vite_inline_asset__ = inlineAsset;
  }

  if (typeof window.__vite_inline_asset_helper !== 'function') {
    window.__vite_inline_asset_helper = inlineAsset;
  }

  if (typeof window.require !== 'function') {
    window.require = function (request) {
      if (typeof request !== 'string') {
        throw new ReferenceError('Dynamic require with non-string argument is not supported in Vite runtime.');
      }

      if (request.startsWith('!svg-inline-loader')) {
        const parts = request.split('!');
        const assetPath = parts[parts.length - 1];
        return window.__vite_inline_svg__(assetPath);
      }

      if (request.endsWith('.svg')) {
        return window.__vite_inline_svg__(request);
      }

      if (IMAGE_EXT_REGEX.test(request)) {
        return window.__vite_inline_asset__(request);
      }

      throw new ReferenceError(`require('${request}') is not supported in Vite runtime.`);
    };
  }
}

export {};
